import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, BookOpenIcon, FileTextIcon, ReceiptIcon, PhoneIcon, CheckSquareIcon, ScaleIcon, LockIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
type ResourceCategory = 'trainee' | 'inchiriere' | 'vanzare';
interface Resource {
  icon: React.ElementType;
  title: string;
  description: string;
  fileType: string;
  category: ResourceCategory;
}
const resources: Resource[] = [{
  icon: BookOpenIcon,
  title: 'Ghidul complet CLC',
  description: 'Manual complet pentru agenți',
  fileType: 'PDF',
  category: 'trainee'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist Onboarding agent',
  description: 'Lista completă de verificare',
  fileType: 'PDF',
  category: 'trainee'
}, {
  icon: ScaleIcon,
  title: 'Regulament intern & Etică profesională',
  description: 'Normele agenției',
  fileType: 'PDF',
  category: 'trainee'
}, {
  icon: PhoneIcon,
  title: 'Scripturi apel proprietar & client',
  description: 'Ghiduri de conversație închiriere',
  fileType: 'PDF',
  category: 'inchiriere'
}, {
  icon: ReceiptIcon,
  title: 'Facturare & TVA – Mini Manual',
  description: 'Ghid fiscal simplificat',
  fileType: 'PDF',
  category: 'inchiriere'
}, {
  icon: FileTextIcon,
  title: 'Checklist dosar închiriere',
  description: 'Documente necesare pentru închiriere',
  fileType: 'PDF',
  category: 'inchiriere'
}, {
  icon: FileTextIcon,
  title: 'Modele contracte intermediere',
  description: 'Template-uri oficiale vânzare',
  fileType: 'PDF',
  category: 'vanzare'
}, {
  icon: CheckSquareIcon,
  title: 'Checklist dosar vânzare',
  description: 'Documente necesare pentru vânzare',
  fileType: 'PDF',
  category: 'vanzare'
}, {
  icon: PhoneIcon,
  title: 'Scripturi apel vânzare',
  description: 'Ghiduri de conversație vânzare',
  fileType: 'PDF',
  category: 'vanzare'
}];
const categories = [{
  id: 'trainee' as ResourceCategory,
  label: 'Trainee',
  requiresAuth: false
}, {
  id: 'inchiriere' as ResourceCategory,
  label: 'Închiriere',
  requiresAuth: true
}, {
  id: 'vanzare' as ResourceCategory,
  label: 'Vânzare',
  requiresAuth: true
}];
export function ResourcesGrid() {
  const {
    isAuthenticated
  } = useAuth();
  const [activeCategory, setActiveCategory] = useState<ResourceCategory>('trainee');
  const filteredResources = resources.filter(r => r.category === activeCategory);
  const isCategoryLocked = categories.find(c => c.id === activeCategory)?.requiresAuth && !isAuthenticated;
  return <div className="py-16" data-id="element-6640">
      {/* Hero Image Section */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="mb-12 rounded-2xl overflow-hidden shadow-2xl" data-id="element-6641">
        <img src="https://images.unsplash.com/photo-1481627834876-b7833e8f5570?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80" alt="Resurse și documente" className="w-full h-64 object-cover" data-id="element-6642" />
      </motion.div>
    </div>;
}